import { render } from "./ModalCriarBug.vue?vue&type=template&id=0e5c4eb4"
import script from "./ModalCriarBug.vue?vue&type=script&lang=js"
export * from "./ModalCriarBug.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__